export default {
  classesList: [],
  usersClassList: [],
}
